import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME, SERVICE_JOB_SPLIT_BILLING, ZAKAZKA_REZERVACE_ND } from './constants';

class Provider extends BaseApi {
    tableUrl(tableName:string) {
		return `/${this.area}/${this.controller}/${tableName}Rows`;
	}
	getServiceJobSplitDetails(serviceJobId: number | null, orderId: number | null) {
		return this.fetch(`/${DMS_MODULE}/ServiceJobDetails/GetServiceJobSplitDetails`, { serviceJobId, orderId });
	}	
	fetchInvoiceStatusOfServiceJobParty(serviceOrderId: number, serviceJobId: number) {
		return this.fetch(`/${DMS_MODULE}/${SERVICE_JOB_SPLIT_BILLING}/FetchInvoiceStatusOfServiceJobPartyCheck`,{serviceOrderId, serviceJobId});
	}
	getInvoicestatusAndSagaStatus(serviceOrderId: number, serviceJobId: number, sagaStatus: boolean | null) {
		return this.fetch(`/${DMS_MODULE}/${SERVICE_JOB_SPLIT_BILLING}/getInvoicestatusAndSagaStatus`,{serviceOrderId, serviceJobId, sagaStatus});
	}
	DeleteServiceJob (serviceJobId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/DeleteServiceJob`,{serviceJobId});
	}
	ServiceJobAvailableReservation(zakazkaId:number, serviceJobId: number){
		return this.fetch(`/${DMS_MODULE}/${ZAKAZKA_REZERVACE_ND}/ServiceJobAvailableReservation`,{zakazkaId, serviceJobId});
	}
}
export const apiProvider = new Provider(DMS_MODULE, NAME);